import React, { createContext, FC, useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Space, Button, notification, Input } from 'antd'
import { CheckCircleOutlined, SmileOutlined } from  '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import * as go from 'gojs'
import { ReactDiagram } from 'gojs-react'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { cloneDeep } from 'lodash'
// import { Inspector } from 'gojs/extensionsTS/DataInspector'
import { getOrganList, addOrganPerson, editOrganPerson, delOrganPerson } from '@/services/organStructure.service'
import '@/pages/table2Mana/components/gojs.css'
// import nodeData from '@/helpers/organStructure.json'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import type { IAppState } from '@/store/reducers'
import type { IOrganPerson } from '@/store/models/organStructure.model'
import EditOrganStucturePop from '@/pages/organStructure/components/editOrganStructurePop'
import { requestFail } from '@/store/actions/common.action'
import { getErrorStr } from '@/store/sagas/table.saga'
import { API } from '@/config'
import defaultHeadImg from '@/assets/images/HSnopic.png'
import Nav from '@/components/nav'
import { RoleCont } from '@/store/constant/auth.constant'

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
type Icb = (item:any) => boolean

const popMsg = (msg: string, type?: string) => {
    const args = {
        message: msg,
        description: '',
        icon: type !== 'error' ? <CheckCircleOutlined style={{ color: '#08993f' }} />
            : <SmileOutlined style={{ color: '#e1931e' }} />,
        duration: 3,
    }
    notification.open(args)
}

function appendData(record: any, nodeDataArray: any[], parentNode: any, searchStatus?: boolean){
    nodeDataArray.push({
        ...record,
        parent: parentNode.id,
        key: record.id, // key 作为 from 和 to 的对应字段
        pic: record.avatar, // pic 每次刷新图片才能显示
        isTreeExpanded: searchStatus ? true : record.orgRole < 2 
    })
}

function appendSubChildren(record: any, nodeDataArray: any[], linkDataArray: { from: any; to: any }[], searchStatus?: boolean) {
    record.key = record.id
    record.pic = record.avatar
    record.children.forEach((item: any) => {
        appendData(item, nodeDataArray, record, searchStatus)
        linkDataArray.push({ from: record.id, to: item.id })
        if (item.children && item.children.length) {
            appendSubChildren(item, nodeDataArray, linkDataArray, searchStatus)
        }
    })
}

export const popShowContext = createContext<{
    isModalOpen: boolean
    closePop: any
    title: string
    nodeData: any
    mode: string
}>({
    isModalOpen: false,
    closePop: null,
    title: '',
    nodeData: null,
    mode: 'add'
})

const OrganList: FC = () => {    
    const dispatch = useDispatch()
    const [isInit, setIsInit] = useState(true)
    const [organPersonList, setOrganPersonList] = useState<IOrganPerson[]>([])
    const [goObj, setGoObj] = useState<any>(null)
    const [showEditPop, setShowEditPop] = useState(false)
    const [editPopTitle, setEditPopTitle] = useState('')
    const [editPopData, setEditPopData] = useState<any>(null)
    const [editPopMode, setEditPopMode] = useState('add')
    const [searchKey, setSearchKey] = useState('')
    const [linkDataArray, setLinkDataArray] = useState<{ from: number; to: number; }[]>([])
    const searchStatus = useRef(false)
    const treeDataRes = useRef<any[]>([])
    const dataArrayRef = useRef<{
        list: IOrganPerson[]
        linkData: { from: number; to: number; }[]
    }>({ list: [], linkData: [] })
    const authInfo = useSelector((state: IAppState) => state.auth.authInfo)
    const route = useSelector((state: IAppState) => state.router)
    const { t, i18n } = useTranslation()
    const history: any = useHistory()
    const { Search } = Input

    
    const roleArr = [
        {
            label: 'ITMT ChairMan',  
            value: RoleCont.ITMTCHAIRMAIN
        },  
        {
            label: 'ITMT Leader',
            value: RoleCont.ITMTLEADER
        },
        {
            label: 'ITMT SubLeader',
            value: RoleCont.ITMTSUBLEADER
        },
        {
            label: t('itmtUser'),
            value: RoleCont.ITMTMEMBER
        },
        {
            label: 'TSP',
            value: RoleCont.TSP
        },
        {
            label: 'PRG',
            value: RoleCont.PRG
        },
        {
            label: 'SecretaryGeneral',
            value: RoleCont.SecretaryGeneral
        },
        {
            label: 'CommitteeMembers',
            value: RoleCont.CommitteeMembers
        },
        {
            label: 'Co-ordinator',
            value: RoleCont.CoOrdinator
        },
        {
            label: 'PLTMT Leader',
            value: RoleCont.PLTMTLeader
        },
        {
            label: 'PLTMT SubLeader',
            value: RoleCont.PL_TMT_SUB_LEADER
        },
        {   
            label: 'PLTMT Member',       
            value: RoleCont.PL_TMT_MEMBER
        }
    ]

    function initDiagram(token: string) {
        const $ = go.GraphObject.make  // for conciseness in defining templates
      
        const myDiagram =
            $(go.Diagram, {
                allowCopy: false,
                allowDelete: false,
                //initialAutoScale: go.Diagram.Uniform,
                maxSelectionCount: 1, // users can select only one part at a time
                validCycle: go.Diagram.CycleDestinationTree, // make sure users can only create trees
                // 'clickCreatingTool.archetypeNodeData': { // allow double-click in background to create a new node
                //     name: '(new person)',
                //     title: '',
                //     comments: ''
                // },
                'clickCreatingTool.insertPart': function(loc: any) {  // override to scroll to the new node
                    const node = go.ClickCreatingTool.prototype.insertPart.call(this as any, loc)
                    if (node !== null) {
                        // this.diagram.select(node)
                        // this.diagram.commandHandler.scrollToPart(node)
                        // this.diagram.commandHandler.editTextBlock(node.findObject('NAMETB'))
                    }
                    return node
                },
                model: new go.GraphLinksModel(
                    {
                        linkKeyProperty: 'key'  // IMPORTANT! must be defined for merges and data sync when using GraphLinksModel
                    }
                ),
                layout: $(go.TreeLayout,
                    {
                        treeStyle: go.TreeLayout.StyleLastParents,
                        arrangement: go.TreeLayout.ArrangementHorizontal,
                        // properties for most of the tree:
                        angle: 90,
                        layerSpacing: 35,
                        // properties for the "last parents":
                        alternateAngle: 90,
                        alternateLayerSpacing: 35,
                        alternateAlignment: go.TreeLayout.AlignmentBus,
                        alternateNodeSpacing: 20
                    }
                ),
                'undoManager.isEnabled': false // enable undo & redo
            })
      
        const levelColors = ['#AC193D', '#2672EC', '#8C0095', '#5133AB',
            '#008299', '#D24726', '#008A00', '#094AB2'];
      
        // override TreeLayout.commitNodes to also modify the background brush based on the tree depth level
        (myDiagram.layout as any).commitNodes = function() {
            (go.TreeLayout.prototype as any).commitNodes.call(this);  // do the standard behavior
            // then go through all of the vertexes and set their corresponding node's Shape.fill
            // to a brush dependent on the TreeVertex.level value
            (myDiagram.layout as any).network.vertexes.each((v: any) => {
                if (v.node) {
                    const level = v.level % (levelColors.length)
                    const color = levelColors[level]
                    const shape = v.node.findObject('SHAPE')
                    if (shape) shape.stroke = $(go.Brush, 'Linear', {
                        0: color, 1: go.Brush.lightenBy(color, 0.05), start: go.Spot.Left, end: go.Spot.Right
                    })
                }
            })
        }
      
        // this is used to determine feedback during drags
        function mayWorkFor(node1: any, node2: any) {
            if (!(node1 instanceof go.Node)) return false  // must be a Node
            if (node1 === node2) return false  // cannot work for yourself
            if (node2.isInTreeOf(node1)) return false  // cannot work for someone who works for you
            return true
        }
      
        // This function provides a common style for most of the TextBlocks.
        // Some of these values may be overridden in a particular TextBlock.
        function textStyle() {
            return { font: '9pt  Segoe UI,sans-serif', stroke: 'white' }
        }
        function textStyle2() {
            return { font: '9pt  Segoe UI,sans-serif', stroke: 'white',
                verticalAlignment: go.Spot.Center,
                wrap: go.TextBlock.WrapBreakAll, width: 100 }
        }
      
        // This converter is used by the Picture.
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        function findHeadShot(pic: string) {
            if (!pic) return defaultHeadImg // There are only 16 images on the server
            return `${API}/api/pangooITMT/orgChart/avatar?path=${encodeURIComponent(pic)}&token=${token}`
        }
    
        function addEmployee(node: any) {
            if (!node) return
            setEditPopTitle(t('add') + (i18n.language !== 'zh' ? ' ' : '') + t('organPerson'))
            setEditPopData({
                parentId: node.data.id,
                id: undefined,
                email: undefined,
                login: undefined,
                avatar: '',
                nickName: undefined,
                orgRole: undefined,
                workGroupId: undefined
            })
            setEditPopMode('add')
            setShowEditPop(true)
        }
      
        // define the Node template
        myDiagram.nodeTemplate =
            $(go.Node, 'Spot',
                {
                    selectionObjectName: 'BODY',
                    mouseEnter: (e, node: any) => {
                        if (node.findObject('BUTTON') && node.findObject('BUTTONX')) {
                            node.findObject('BUTTON').opacity = node.findObject('BUTTONX').opacity = 1
                        }
                    },
                    mouseLeave: (e, node: any) => {
                        if (node.findObject('BUTTON') && node.findObject('BUTTONX')) {
                            node.findObject('BUTTON').opacity = node.findObject('BUTTONX').opacity = 0
                        }
                    },
                    // handle dragging a Node onto a Node to (maybe) change the reporting relationship
                    mouseDragEnter: (e, node: any) => {
                        const diagram = node.diagram
                        const selnode = diagram.selection.first()
                        if (!mayWorkFor(selnode, node)) return
                        const shape = node.findObject('SHAPE')
                        if (shape) {
                            shape._prevFill = shape.fill  // remember the original brush
                            shape.fill = 'darkred'
                        }
                    },
                    mouseDragLeave: (e, node: any) => {
                        const shape = node.findObject('SHAPE')
                        if (shape && shape._prevFill) {
                            shape.fill = shape._prevFill  // restore the original brush
                        }
                    },
                    // mouseDrop: (e, node: any) => {
                    //     const diagram = node.diagram
                    //     const selnode = diagram?.selection.first()  // assume just one Node in selection
                    //     if (mayWorkFor(selnode, node)) {
                    //         // find any existing link into the selected node
                    //         const link = selnode?.findTreeParentLink()
                    //         if (link !== null) {  // reconnect any existing link
                    //             link.fromNode = node
                    //         } else {  // else create a new link
                    //             diagram?.toolManager.linkingTool.insertLink(node, node.port, selnode, selnode.port)
                    //         }
                    //     }
                    // }
                },
                // for sorting, have the Node.text be the data.name
                new go.Binding('text', 'name'),
                // bind the Part.layerName to control the Node's layer depending on whether it isSelected
                new go.Binding('layerName', 'isSelected', sel => sel ? 'Foreground' : '').ofObject(),
                $(go.Panel, 'Auto',
                    { name: 'BODY' },
                    // define the node's outer shape
                    $(go.Shape, 'Rectangle',
                        { name: 'SHAPE', fill: '#333333', stroke: 'white', strokeWidth: 2.5, portId: '' }),
                    $(go.Panel, 'Horizontal',
                        $(go.Picture,
                            {
                                name: 'Picture',
                                desiredSize: new go.Size(60, 70),
                                margin: 1.5,
                            },
                            // 字段名必须为 pic
                            new go.Binding('source', 'pic', findHeadShot)
                        ),
                        // define the panel where the text will appear
                        $(go.Panel, 'Table',
                            {
                                minSize: new go.Size(130, NaN),
                                maxSize: new go.Size(180, NaN),
                                margin: new go.Margin(6, 10, 0, 6),
                                defaultAlignment: go.Spot.Left
                            },
                            $(go.RowColumnDefinition, { column: 3, width: 4 }),
                            $(go.TextBlock, textStyle(),  // the name
                                {
                                    name: 'nickName',
                                    row: 0, column: 0, columnSpan: 4,
                                    font: '12pt Segoe UI,sans-serif',
                                    editable: false, isMultiline: false,
                                    minSize: new go.Size(50, 16),
                                    margin: new go.Margin(0, 0, 5, 0)
                                },
                                new go.Binding('text', 'nickName').makeTwoWay()),
                            $(go.TextBlock, `${t('WorkGroup')}: `, textStyle(),
                                { row: 1, column: 0, columnSpan: 1 }),
                            $(go.TextBlock, textStyle2(),
                                {
                                    row: 1, column: 1, columnSpan: 3,
                                    font: '8pt sans-serif',
                                    editable: false, isMultiline: true,
                                    minSize: new go.Size(50, 20),
                                    margin: new go.Margin(0, 0, 0, 10)
                                },
                                new go.Binding('text', 'workGroup',
                                    v => {
                                        return v ? v.workGroupName : `${t('Null Value')} `
                                    }
                                ).makeTwoWay(),
                            ),
                            // 所属 Bu
                            $(go.TextBlock, `${t('belongBU')}: `, textStyle(),
                                { row: 2, column: 0, columnSpan: 1 }),
                            $(go.TextBlock, textStyle2(),
                                {
                                    row: 2, column: 1, columnSpan: 3,
                                    font: '8pt sans-serif',
                                    editable: false, isMultiline: true,
                                    minSize: new go.Size(50, 20),
                                    margin: new go.Margin(0, 0, 0, 10)
                                },
                                new go.Binding('text', 'bu',
                                    v => {
                                        return v ? v : `${t('Null Value')} `
                                    }
                                ).makeTwoWay(),
                            ),
                            // $(go.TextBlock, textStyle(),
                            //     { row: 2, column: 0, columnSpan: 5 },
                            //     new go.Binding('text', 'createTime', v => `${t('createTime')}: ` + moment(v).format('YYYY-MM-DD'))),
                            $(go.TextBlock, `${t('orgRole')}: `, textStyle(),
                                { row: 3, column: 0, columnSpan: 1 }),
                            $(go.TextBlock, textStyle2(),  // the comments
                                {
                                    row: 3, column: 1, columnSpan: 3,
                                    font: '9pt sans-serif',
                                    wrap: go.TextBlock.WrapFit,
                                    editable: false,  // by default newlines are allowed
                                    minSize: new go.Size(100, 20),
                                    margin: new go.Margin(0, 0, 0, 10)
                                },
                                new go.Binding('text', 'orgRole',
                                    v => {
                                        // ITMT ChairMan:1，ITMT Leader:2，ITMT SubLeader:3，ITMT成员:4, TSP:5,
                                        // PRG:6, 秘书长：7，委员：8, 统筹人：9, PLTMT Leader:10,
                                        return (roleArr[v - 1] .label || '')
                                    }
                                ).makeTwoWay())
                        ) // end Table Panel
                    ) // end Horizontal Panel
                ), // end Auto Panel
                authInfo && Reflect.has(authInfo, 'editOrganPerson') ? $('Button',
                    $(go.Shape, 'PlusLine', { width: 10, height: 10 }),
                    {
                        name: 'BUTTON', alignment: go.Spot.Right, opacity: 0,  // initially not visible
                        click: (e, button) => {
                            addEmployee(button.part)
                        }
                    },
                    // button is visible either when node is selected or on mouse-over
                    new go.Binding('opacity', 'isSelected', s => s ? 1 : 0).ofObject()
                ) : '',
                new go.Binding('isTreeExpanded').makeTwoWay(),
                $('TreeExpanderButton',
                    {
                        name: 'BUTTONX', alignment: go.Spot.Bottom, opacity: 0,  // initially not visible
                        '_treeExpandedFigure': 'TriangleUp',
                        '_treeCollapsedFigure': 'TriangleDown'
                    },
                    // button is visible either when node is selected or on mouse-over
                    new go.Binding('opacity', 'isSelected', s => s ? 1 : 0).ofObject()
                )
            )  // end Node, a Spot Panel
        myDiagram.nodeTemplate.contextMenu =
            $('ContextMenu',
                authInfo && Reflect.has(authInfo, 'editOrganPerson') ? $('ContextMenuButton',
                    $(go.TextBlock, '' + t('Edit Person')),
                    {
                        click: async (e, button) => {
                            const node = (button.part as any).adornedPart
                            if (node !== null && node !== undefined) {
                                Reflect.deleteProperty(node.data, 'parentObj')
                                console.log('node.data: ', JSON.parse(JSON.stringify(node.data)))
                                setEditPopTitle(t('edit') + (i18n.language !== 'zh' ? ' ' : '') + t('organPerson'))
                                setEditPopData({
                                    ...node.data,
                                    avatar:  node.data.avatar ? `${API}/api/pangooITMT/orgChart/avatar?path=${encodeURIComponent(node.data.avatar)}&token=${token}` : ''
                                })
                                setEditPopMode('edit')
                                setShowEditPop(true)
                            }
                        }
                    }
                ) : '',
                authInfo && Reflect.has(authInfo, 'delOrganPerson') ? $('ContextMenuButton',
                    $(go.TextBlock, '' + t('Remove Person')),
                    {
                        click: async (e, button) => {
                            // reparent the subtree to this node's boss, then remove the node
                            const node = (button.part as any).adornedPart
                            if (node !== null) {
                                const chl = node.findTreeChildrenNodes()
                                // iterate through the children and set their parent key to our selected node's parent key
                                if (chl.next()) {
                                    // 有子级不能删除
                                    dispatch(requestFail(t('hasChildrenNoDel') + '--' + Math.random()))
                                    return
                                }
                                try {
                                    await delOrganPerson(node.data.id)
                                    // and now remove the selected node itself
                                    myDiagram.model.removeNodeData(node.data)
                                    const filterLink = dataArrayRef.current.linkData.filter(item => {
                                        return item.to !== node.data.id
                                    })
                                    
                                    setLinkDataArray(filterLink)
                                    const filterList = dataArrayRef.current.list.filter(item => {
                                        return item.id !== node.data.id
                                    })
                                    setOrganPersonList(filterList)
                                } catch (error: any) {
                                    const str = getErrorStr(error)
                                    dispatch(requestFail(str))
                                }
                            }
                        }
                    }
                ) : '',
                authInfo && Reflect.has(authInfo, 'viewOrganPerson') ? $('ContextMenuButton',
                    $(go.TextBlock, '' + t('View Person')),
                    {
                        click: (e, button) => {
                            // reparent the subtree to this node's boss, then remove the node
                            const node = (button.part as any).adornedPart
                            if (node !== null) {
                                console.log(node.data)
                                setEditPopTitle(t('view') + (i18n.language !== 'zh' ? ' ' : '') + t('organPerson'))
                                setEditPopData({
                                    ...node.data,
                                    avatar:  node.data.avatar ? `${API}/api/pangooITMT/orgChart/avatar?path=${encodeURIComponent(node.data.avatar)}&token=${token}` : ''
                                })
                                setEditPopMode('view')
                                setShowEditPop(true)
                            }
                        }
                    }
                ) : '',
            )
        myDiagram.linkTemplate =
            $(go.Link, go.Link.Orthogonal,
                { layerName: 'Background', corner: 5 },
                $(go.Shape, { strokeWidth: 1.5, stroke: '#999' }))  // the link shape
    
        // new Inspector('', myDiagram,
        //     {
        //         properties: {
        //             'key': { readOnly: true },
        //             'comments': {}
        //         }
        //     }
        // )
        return myDiagram
    }

    const getOrganListFn = async () => {
        const res = await getOrganList()
        console.log('getOrganListFn: ', res)
        treeDataRes.current = res
        const _linkDataArray: { from: number; to: number; }[] = []
        if (res.length) {
            if (searchKey === '') {
                appendSubChildren(res[0], res, _linkDataArray)
                setLinkDataArray(_linkDataArray)
                setOrganPersonList([...res])
            } else {
                onChangeSearch(searchKey)
            }
        }
        setIsInit(false)
    }
    const onChangeSearch = (val: string) => {
        setSearchKey(val)
        const _linkDataArray: { from: number; to: number; }[] = []
        // 搜索时展示所有层级，为空条件时或初始加载时则只显示2级
        if (val === '') {
            searchStatus.current = false
            appendSubChildren(treeDataRes.current[0], treeDataRes.current, _linkDataArray, searchStatus.current)
            setLinkDataArray(_linkDataArray)
            setOrganPersonList([...treeDataRes.current])
            return
        }
        const result = searchTree(JSON.parse(JSON.stringify(treeDataRes.current)), item => 
            item.nickName.toLowerCase().indexOf(val.toLowerCase()) !== -1
        )
        if (result?.length) {
            searchStatus.current = true
            appendSubChildren(result[0], result, _linkDataArray, searchStatus.current)
            setLinkDataArray(_linkDataArray)
            setOrganPersonList([...result])
        } else {
            popMsg(`${t('searchNoUser')}\n(${t('searchUserPrompt')})`, 'error')
        }
    }
    const handleModelChange = async (e: any) => {
        console.log('handleModelChange: ', e)
        // if (isInit) {
        //     return
        // }
        // try {
        //     const res = await editOrganPerson(e.modifiedNodeData[0])
        //     console.log('res: ', res)
        // } catch (error: any) {
        //     const str = getErrorStr(error)
        //     dispatch(requestFail(str))
        // }
    }
    const zoomToFit = () => {
        goObj && goObj.commandHandler.zoomToFit()
    }
    const centerOnRoot = (key?: any) => {
        if (typeof key !== 'number') {
            key = organPersonList.length ? organPersonList[0].id : undefined
        }
        if (key && goObj) {
            goObj.scale = 1
            goObj.commandHandler.scrollToPart(goObj.findNodeForKey(key))
        }
    }
    const closeEditPop = async (values: any) => {
        console.log('close: ', values)
        setShowEditPop(false)
        if (values) {
            if (values.type === 'click') return
            try {
                let res: any
                if (values.id) {
                    // 修改
                    res = await editOrganPerson(values)
                } else {
                    res = await addOrganPerson(values)
                }
                console.log('addOrganPerson: ', res)
                popMsg(t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('success'))
                getOrganListFn()
                centerOnRoot(res)
                // const newemp = {
                //     ...values,
                //     id: res,
                //     parent: values.parentId
                // }
                // goObj.startTransaction('add employee')
                // goObj.model.addNodeData(newemp)
                // const newnode = goObj.findNodeForData(newemp)
                // goObj.commitTransaction('add employee')
                // goObj.commandHandler.scrollToPart(newnode || undefined)
            } catch (error: any) {
                const str = getErrorStr(error)
                dispatch(requestFail(str))
            }
        }
    }
    // 搜索树中满足条件的节点，并保留分支
    // const searchTree = (tree: any[], cb: Icb) => {
    //     const getNodes = (result: any[], object: any) => {
    //         if (cb(object)) {
    //             result.push(object)
    //         }
    //         if (object.children.length > 0) {
    //             const nodes = object.children.reduce(getNodes, [])
    //             if (nodes.length > 0) {
    //                 result.push({
    //                     ...object,
    //                     children: nodes
    //                 })
    //             }
    //         }
    //         return result
    //     }
    
    //     return tree.reduce(getNodes, [])
    // }
    const searchTree = (tree: any[], cb: Icb) => {
        let stack: any[] = []
        const mapObj: Record<string, any> = {}
        const resultObj: Record<string, any> = {}
        const resultObj2: Record<string, any> = {}
        let resultObj3: any
        stack = stack.concat(tree)
        while (stack.length) {
            const item = stack.shift()
            if (item.children) {
                const { id } = item
                mapObj[id] = item
                let findFlag = false
                item.children.forEach((subItem: any) => {
                    subItem.parentObj = item
                    mapObj[subItem.id] = subItem.parentObj
                    if (cb(subItem)) {
                        resultObj[subItem.id] = subItem
                        findFlag = true
                    }
                    stack.push(subItem)
                })
                if (!findFlag) {
                    item.children = []
                }
            }
        }
        let stack2: any[] = []
        stack2 = stack2.concat(Object.values(resultObj))
        while (stack2.length > 0) {
            const item = stack2.shift()
            // Reflect.deleteProperty(item, 'avatar')
            // Reflect.deleteProperty(item, 'createTime')
            // Reflect.deleteProperty(item, 'creator')
            // Reflect.deleteProperty(item, 'email')
            // Reflect.deleteProperty(item, 'login')
            // Reflect.deleteProperty(item, 'modifyTime')
            // Reflect.deleteProperty(item, 'orgRole')
            // Reflect.deleteProperty(item, 'updator')
            // Reflect.deleteProperty(item, 'version')
            // Reflect.deleteProperty(item, 'workGroup')
            if (item.children) {
                item.children.forEach((subItem: any) => {
                    stack2.push(subItem)
                })
            }
        }
        stack2 = stack2.concat(Object.values(resultObj))
        while (stack2.length > 0) {
            const item = stack2.shift()
            if (item.parentObj) {
                if (!resultObj2[item.parentObj.id]) {
                    item.parentObj.children = [item]
                    resultObj2[item.parentObj.id] = item.parentObj
                } else {
                    const findObj = item.parentObj.children.find((subItem: any) => subItem.id === item.id)
                    if (!findObj) {
                        item.parentObj.children.push(item)
                        // item.parentObj.children.sort((a: any, b: any) => a.id - b.id)
                    }
                }
                stack2.push(item.parentObj)
            } else {
                resultObj3 = item
            }
        }
        // console.log('mapObj: ', mapObj)
        if (resultObj3) {
            return [resultObj3]
        } else {
            return null
        }
    }
    const routes = [
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/organStructure',
            breadcrumbName: t('organStructure'),
        },
    ]
    useEffect(() => {
        getOrganListFn()
    }, [])
    useEffect(() => {
        dataArrayRef.current.linkData = linkDataArray
    }, [linkDataArray])
    useEffect(() => {
        dataArrayRef.current.list = organPersonList
    }, [organPersonList])


    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                route={route}
                dispatch={dispatch}
            />
            <Space direction='vertical' style={{ position: 'relative', width: '100%' }}>
                <Space>
                    <Search style={{ width: 350 }} allowClear
                        placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('organPerson') + (i18n.language !== 'zh' ? ' ' : '') + ', ' + t('organPersonTips')}
                        enterButton={t('search')}
                        onSearch={onChangeSearch}
                    />
                    {!isInit && organPersonList.length === 0 && <Button type='primary'
                        onClick={() => {
                            setEditPopTitle(t('add') + (i18n.language !== 'zh' ? ' ' : '') + t('organPerson'))
                            setEditPopData({
                                parentId: undefined,
                                id: undefined,
                                email: undefined,
                                login: undefined,
                                avatar: '',
                                nickName: undefined,
                                orgRole: undefined,
                                workGroupId: undefined
                            })
                            setEditPopMode('add')
                            setShowEditPop(true)
                        }}
                    >{t('addTopOrganPerson')}</Button>}
                </Space>
                {authInfo && <ReactDiagram
                    initDiagram={() => {
                        let token = localStorage.getItem('userInfo')
                        if (token) {
                            token = JSON.parse(token).token
                        } else {
                            token = ''
                        }
                        const myDiagram = initDiagram(token as string)
                        setGoObj(myDiagram)
                        return myDiagram
                    }}
                    divClassName='orgin-structure'
                    nodeDataArray={organPersonList}
                    linkDataArray={linkDataArray}
                    onModelChange={handleModelChange}
                />}
                <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button onClick={zoomToFit}>{t('Zoom To Fit')}</Button>
                    <Button onClick={centerOnRoot}>{t('Center on Root')}</Button>
                </Space>
            </Space>
            <popShowContext.Provider value={{ 
                isModalOpen: showEditPop,
                closePop: closeEditPop,
                title: editPopTitle,
                nodeData: editPopData,
                mode: editPopMode
            }}>
                <EditOrganStucturePop />
            </popShowContext.Provider>
        </Space>
    )
}

export default OrganList